import { render, staticRenderFns } from "./dialog_addGroup.vue?vue&type=template&id=aff8f550&scoped=true&"
import script from "./dialog_addGroup.vue?vue&type=script&lang=js&"
export * from "./dialog_addGroup.vue?vue&type=script&lang=js&"
import style0 from "./dialog_addGroup.vue?vue&type=style&index=0&id=aff8f550&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff8f550",
  null
  
)

export default component.exports